const mjmlTemplate = `<mjml>
  <mj-head>
    <mj-attributes>
      <mj-all font-family="Inter, Arial, sans-serif" color="#3b4c56" />
      <mj-text font-size="15px" line-height="1.6" padding="0" />
      <mj-section padding="0" />
      <mj-column padding="0" />
    </mj-attributes>
    <mj-preview>
      {{preheaderText}}
    </mj-preview>
    <mj-style inline="inline">
      .markdown p + p { margin-top: 10px; }
      .markdown ul, .markdown ol { margin: 10px 0; padding-left: 20px; }
      .markdown li + li { margin-top: 6px; }
      .markdown a { color: inherit; text-decoration: underline; }
      .markdown strong { font-weight: 600; }
      .markdown em { font-style: italic; }
      .legal a { color: inherit !important; text-decoration: underline; }
      .legal-links a { cursor: pointer; }
      .social-icon {
        width: 30px !important; height: 30px !important; border-radius: 30px !important;
        background-color: rgba(255,255,255,0.7); display: inline-block;
      }
      .display-title div {
        font-family: Arial, sans-serif !important;
        font-size: 18px !important;
        line-height: 1.3 !important;
        font-weight: 400 !important;
        color: #111827 !important;
        text-align: center !important;
      }
      .subscription-tagline div {
        font-family: Arial, sans-serif !important;
        font-size: 14px !important;
        line-height: 1.4 !important;
        color: #4b5563 !important;
        text-align: center !important;
      }
      .subscription-contact-heading div {
        font-size: 11px !important;
        letter-spacing: 0.16em !important;
        text-transform: uppercase !important;
        font-weight: 600 !important;
        color: #111827 !important;
        text-align: left !important;
      }
      .subscription-contact-body div,
      .subscription-contact-body a {
        font-size: 12px !important;
        line-height: 1.6 !important;
        color: #3b4c56 !important;
        text-align: left !important;
      }
      .subscription-footer-logo img {
        width: auto !important;
        max-width: 96px !important;
        height: auto !important;
        max-height: 56px !important;
      }
      .subscription-footer-social td {
        text-align: left !important;
      }
      .subscription-copyright div,
      .subscription-copyright a {
        color: #8b8b8b !important;
        font-size: 11px !important;
      }
    </mj-style>
  </mj-head>
  <mj-body background-color="#EEF1F7" width="600px">
    <mj-wrapper padding="0">
      <mj-section background-color="{{headerBgColor}}" padding="38px 30px 28px" css-class="mjml-header">
        <mj-column>
          <mj-image src="{{logoUrl}}" alt="Logo" align="center" padding="0" width="{{logoWidth}}" height="{{logoHeight}}" css-class="mjml-logo" />
        </mj-column>
      </mj-section>

      <mj-section padding="0 34px" css-class="mjml-hero" background-color="#FFFFFF">
        <mj-column>
          <mj-image src="{{heroImgUrl}}" alt="Hero" padding="0" href="{{heroImageLinkUrl}}" />
        </mj-column>
      </mj-section>

      <mj-section padding="34px 34px 22px" css-class="mjml-body" background-color="#FFFFFF">
        <mj-column>
          <mj-text css-class="display-title" align="center" padding="0 0 16px 0">
            {{emailTitle}}
          </mj-text>
          <mj-text css-class="markdown" align="center" padding="0" line-height="1.7" font-size="15px">
            <!-- bodyHtml -->
          </mj-text>
          <mj-spacer height="22px" />
          <mj-button
            href="{{ctaUrl}}"
            background-color="{{ctaBackgroundColor}}"
            color="{{ctaTextColor}}"
            font-weight="600"
            font-size="14px"
            letter-spacing="0.08em"
            text-transform="uppercase"
            width="220px"
            align="center"
            padding="0"
            inner-padding="14px 28px"
            border-radius="2px"
            css-class="mjml-cta"
          >
            {{ctaText}}
          </mj-button>
          <mj-spacer height="24px" />
          <mj-text css-class="subscription-tagline" align="center" padding="0">
            {{headerTaglineScript}}
          </mj-text>
        </mj-column>
      </mj-section>

      <mj-section padding="20px 34px 0" css-class="mjml-footer" background-color="#FFFFFF">
        <mj-column>
          <mj-divider border-width="1px" border-color="#d8d8d8" padding="0 0 28px 0" />
        </mj-column>
      </mj-section>
      <mj-section padding="0 34px 28px" css-class="mjml-footer" background-color="#FFFFFF">
        <mj-column width="36%" vertical-align="top">
          <mj-image src="{{logoUrl}}" alt="Logo" align="left" padding="6px 0 0 0" width="96px" css-class="subscription-footer-logo" />
        </mj-column>
        <mj-column width="64%" vertical-align="top">
          <mj-text css-class="subscription-contact-heading" align="left" padding="0 0 12px 0">
            Get in touch
          </mj-text>
          <mj-text css-class="subscription-contact-body" align="left" padding="0 0 8px 0">
            <p style="margin:0 0 4px 0;font-weight:600;">{{hotelName}}</p>
            <p style="margin:0 0 4px 0;">{{hotelAddress}}</p>
            <p style="margin:0 0 8px 0;">{{hotelCityStateZip}}</p>
            <p style="margin:0 0 4px 0;">
              <a href="{{hotelWebsiteUrl}}" style="color:#3b4c56;text-decoration:underline;">{{hotelWebsite}}</a>
            </p>
            <p style="margin:0;">
              <a href="tel:{{hotelPhone}}" style="color:#3b4c56;text-decoration:underline;">{{hotelPhone}}</a>
            </p>
          </mj-text>
          <mj-table css-class="subscription-footer-social" align="left" padding="16px 0 0 0">
            <tr>
              <td style="text-align: left;">
                <!-- socialMediaLinksHtml -->
              </td>
            </tr>
          </mj-table>
        </mj-column>
      </mj-section>
      <mj-section padding="0 34px 28px" css-class="mjml-footer" background-color="#FFFFFF">
        <mj-column>
          <mj-text align="left" css-class="subscription-copyright" padding="0 0 12px 0">
            © {{hotelName}}. All rights reserved.
          </mj-text>
          <mj-divider border-width="1px" border-color="#d8d8d8" padding="0 0 12px 0" />
          <mj-text align="left" font-size="11px" css-class="legal subscription-copyright" padding="0" color="#8b8b8b">
            <div class="legal-links" style="opacity:.5;">
              <a style="text-decoration: none;" href="{{privacyPolicyUrl}}">Privacy</a>
              <span style="display:inline-block;width:10px;font-size:9px;">|</span>
              <a style="text-decoration: none;" href="{{termsUrl}}">Terms</a>
              <span style="display:inline-block;width:10px;font-size:9px;">|</span>
              <a style="text-decoration: none;" href="{{unsubscribeUrl}}">Unsubscribe</a>
            </div>
          </mj-text>
        </mj-column>
      </mj-section>
    </mj-wrapper>
  </mj-body>
</mjml>`

export default mjmlTemplate
